import JSX, {h, Component, AnyComponent, ComponentChildren} from 'preact'
import TextButton from '../ui-components/TextButton'
import {isFunction} from "../../libs/typeGuards";
import GlobalClick from '../interactive/documentClick'

interface Props {
  popupName: string,
  triggerClass?: string,
  class?: string,
  triggerElement?: AnyComponent<{onClick: (e: Event) => void, disabled?: boolean}> | string,
  trigger?: ComponentChildren,
  children: JSX.Element,
  closeOnDropdownClick?: boolean,
  disabled?: boolean
}

interface State {
  isOpen: boolean,
  isTriggerClicked: boolean
}

export default class extends Component<Props, State> {
  render (props: Props) {
    const Trigger = props.triggerElement || TextButton
    return <div className={`dropdown-container ${props.triggerClass || ''}`}>
      <Trigger
        aria-haspopup={props.popupName}
        aria-expanded={this.state.isOpen}
        disabled={props.disabled}
        onClick={() => {
          if (props.disabled) {
            return
          }
          this.setState({ isOpen: !this.state.isOpen, isTriggerClicked: true })
        }}>
        {props.trigger}
      </Trigger>
      <GlobalClick
        Component='ul'
        tabIndex={-1}
        role={props.popupName}
        className={`${props.class || ''} ${!this.state.isOpen ? 'is-hidden' : ''}`}
        onChildrenClick={() => props.closeOnDropdownClick ? this.setState({ isOpen: false, isTriggerClicked: false }) : ''}
        onGlobalClick={() => {
          this.state.isTriggerClicked ? this.setState({ isTriggerClicked: false }) : this.setState({ isOpen: false, isTriggerClicked: false })}}
      >
        {isFunction(props.children[0]) && props.children[0]({
          close: () => this.setState({ isOpen: false, isTriggerClicked: false })
        })}
        {props.children}
      </GlobalClick>
    </div>
  }
}
